<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-baoming"></i>
      {{ id ? '报名表编辑' : '报名表新增' }}
    </div>
    <div class="padding-sm">
      <el-form :model="sginForm" :rules="rules" ref="sginForm" label-width="100px">
        <el-form-item label="报名表名称" prop="title">
          <el-input v-model="sginForm.title" placeholder="请输入报名表名称"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="sginForm.desc" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="sginForm.type">
            <el-radio label="1">培训报名</el-radio>
            <el-radio label="2">考试报名</el-radio>
<!--            <el-radio label="3">考务报名</el-radio>-->
<!--            <el-radio label="4">考官报名</el-radio>-->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义表单">
          <el-table
              :data="signSome"
              header-row-class-name="table-header"
              row-class-name="table-row"
              alig="center"
              fit
              style="width: 100%"
          >
            <el-table-column label="表单项">
              <template slot-scope="scope">
                <div class="table-item padding-left-sm flex align-center" v-if="scope.row.type === 1">
                  <p><span v-if="Number(scope.row.state) === 1">*</span>{{ scope.row.name }}:</p>
                  <input type="text" :placeholder="scope.row.placeholder">
                </div>
                <div class="table-item padding-left-sm flex align-start" v-if="scope.row.type === 2">
                  <p><span v-if="Number(scope.row.state) === 1">*</span>{{ scope.row.name }}:</p>
                  <textarea :placeholder="scope.row.placeholder" ></textarea>
                </div>
                <div class="table-item padding-left-sm" v-if="scope.row.type === 3">
                  <p><span v-if="Number(scope.row.state) === 1">*</span>{{ scope.row.name }}</p>
                  <div class="flex align-center flex-wrap">
                    <span class="flex align-center margin-right" v-for="items in scope.row.option" :key="items[0]">
                      <input type="radio"  disabled class="radio"/><span class="margin-left-xs">{{ items[1] }}</span>
                    </span>
                  </div>
                </div>
                <div class="table-item padding-left-sm" v-if="scope.row.type === 4">
                  <p><span v-if="Number(scope.row.state) === 1">*</span>{{ scope.row.name }}</p>
                  <div class="flex align-center flex-wrap">
                    <span class="flex align-center margin-right" v-for="items in scope.row.option" :key="items[0]">
                      <input type="checkbox" disabled class="radio"/> <span class="margin-left-xs">{{ items[1] }}</span>
                    </span>
                  </div>
                </div>
                <div class="table-item padding-left-sm" v-if="scope.row.type === 5">
                  <p><span v-if="Number(scope.row.state) === 1">*</span>{{ scope.row.name }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="100px">
              <template slot-scope="scope">
                <div class="table-item">
                  {{ scope.row.type | type }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="100px">
              <template slot-scope="scope">
                <div class="table-item">
                  {{ Number(scope.row.state) === 1 ? '必填' : '选填' }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200px">
              <template slot-scope="scope" v-if="scope.$index>4">
                <div class="table-operate">
                  <el-button
                      size="medium"
                      type="primary"
                      @click="editItem(scope.$index)"
                  >编辑
                  </el-button>
                  <el-button
                      size="medium"
                      type="danger"
                      @click="deleteItem(scope.$index)"
                  >删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="flex align-center justify-around margin-tb "><el-button type="primary"  @click="signupDialog = true">添加</el-button></div>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl submit-btn" type="primary" @click="submitForm('sginForm')">提交</el-button>
        </el-form-item>
      </el-form>

    </div>
        <signup-dialog
            :setId="setId"
            :setItem="setItem"
            :signupDialog="signupDialog"
            @cancelDialog="cancelDialog"
        />
  </div>
</template>

<script>
import {getExamEnroll, addExamEnroll, examEnrollClumnList} from "@/api/projectOffice";
import signupDialog from "@/views/projectOffice/page/dialog/signupDialog";

export default {
  name: "signupEdit",
  data() {
    return {
      id: '',
      sginForm: {
        title: '',
        type: '2',
        desc: '',
        enroll_diy_id: [1,2,3,4,6],
      },
      signList: [],
      rules: {
        title: [
          {required: true, message: '请输入报名表名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择类型', trigger: 'change'},
        ],
      },
      signupDialog:false,
      setId: 0,
      setItem: {},
    };
  },
  components: {
    signupDialog
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/signup',
        "当前位置：报名表管理 > 报名表编辑",
        true
    );
    this.id = this.$route.query.id
    if (this.id) this.getDetail();
    this.getExamEnrollClumnList()
  },
  computed: {
    signSome() {
      let _arr = JSON.parse(JSON.stringify(this.signList))
      _arr.map(item => {
        if (item.type === 3 || item.type === 4) {
          item.value = item.value.split('|')
          item.option = []
          item.value.map(items => {
            items = items.split(',')
            item.option.push(items)
          })
        }
      })
      return _arr
    }
  },
  methods: {
    async getDetail() {
      let _data = await getExamEnroll(this.id)
      this.sginForm = {
        title: _data.data.title,
        type: _data.data.type.toString(),
        desc: _data.data.desc,
        enroll_diy_id: _data.data.enroll_diy_id.split(','),
      }
    },

    editItem(index){
      console.log(index)
      this.setItem = this.signSome[index];
      this.setId = this.signSome[index].id;
      this.signupDialog = true;
    },
    deleteItem(index){
      this.$confirm("确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sginForm.enroll_diy_id.splice(index,1)
      });
    },



    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _data = await addExamEnroll(
          this.sginForm.title,
          this.sginForm.type,
          this.sginForm.desc,
          this.sginForm.enroll_diy_id.join(','),
          this.id ? this.id : '',
      );
      this.$message.success(_data.msg);
      this.$router.go(-1)
    },
    async upDetail() {
      let _state = await addExamEnroll(
          this.sginForm.title,
          this.sginForm.type,
          this.sginForm.desc,
          this.sginForm.enroll_diy_id,
      )
      console.log(_state)
    },
    cancelDialog(val) {
      if (val[0]) {
        this.setId = 0;
        this.setItem = {};
        this.signupDialog = false;
        if(this.sginForm.enroll_diy_id.indexOf(Number(val[1]))===-1){
          this.sginForm.enroll_diy_id.push(Number(val[1]))
        }else{
          this.getExamEnrollClumnList()
        }

      } else {
        this.setId = 0;
        this.setItem = {};
        this.signupDialog = false;
      }
    },
    async getExamEnrollClumnList(){
      let _data = await examEnrollClumnList('',this.sginForm.enroll_diy_id.join(','))
      this.signList = _data.data
    }
  },
  watch:{
    'sginForm.enroll_diy_id': {
      handler(newName, oldName) {
        this.getExamEnrollClumnList()
      },
      immediate: true,
      deep: true
    }
  },
  filters: {
    type(num) {
      switch (Number(num)) {
        case 1:
          return '单行文本'
        case 2:
          return '多行文本'
        case 3:
          return '单选题'
        case 4:
          return '多选题'
        case 5:
          return '图片'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.table-item {
  p {
    span {
      color: #e4396c;
    }
  }

  input {
    display: block;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #eee;
    margin-left: 10px;
  }
  input.radio{
    margin: 0;
  }
  textarea{
    display: block;
    border: 1px solid #eee;
    height: 60px;
    padding: 0 10px;
    margin-left: 10px;
  }
}
</style>